module.exports = __webpack_public_path__ + "img/stegeman-commencement-streamers.3a32438d.jpg";